export default __webpack_public_path__ + "static/media/tutorial_preview_feasibility_checker.fb0cd7ac.png";